/** @format */

export const educationResponsibilityInfoTypeModelModule = 'sis-components.model.educationResponsibilityInfoType';

(function () {
    initEducationResponsibilityInfoTypeModel.$inject = ['educationResponsibilityInfoTypeJSDataModel', '$http', '$log'];
    educationResponsibilityInfoTypeModel.$inject = ['DS'];
    angular
        .module(educationResponsibilityInfoTypeModelModule, ['js-data'])
        .factory('educationResponsibilityInfoTypeJSDataModel', educationResponsibilityInfoTypeModel)
        .run(initEducationResponsibilityInfoTypeModel);

    var ENDPOINT = '/kori/api/cached/codebooks/urn:code:education-responsibility-info-type';

    function educationResponsibilityInfoTypeModel(DS) {
        return DS.defineResource({
            idAttribute: 'urn',
            name: 'educationResponsibilityInfoType',
            endpoint: ENDPOINT,
            watchChanges: false,
        });
    }

    function initEducationResponsibilityInfoTypeModel(educationResponsibilityInfoTypeJSDataModel, $http, $log) {
        $http
            .get(ENDPOINT)
            .then(function (response) {
                educationResponsibilityInfoTypeJSDataModel.inject(_.values(response.data));
            })
            .catch(function (error) {
                $log.error(error);
            });
    }
})();
